module.exports = __webpack_public_path__ + "img/help-circle-outline.d8302a2.svg";